import { LicensingPeriods as DDELicensingPeriods } from './dde'
import { DGELicensingPeriods } from './streaming'

export type { StreamingLicensingPeriod } from './streaming'
export { useLicensingPeriods } from './useLicensingPeriods'

export const LicensingPeriods = {
  DDE: DDELicensingPeriods,
  DGE: DGELicensingPeriods
}
